// src/providers/ProdutoProviders.js
// src/providers/ProdutosProvider.js
import React from 'react';
import { UnMedidaProvider } from '../contexts/produtos/UnMedidaContext';
import { GrupoProvider } from '../contexts/produtos/GrupoContext';
import { SubGrupoProvider } from '../contexts/produtos/SubGrupoContext';
import { MarcaProvider } from '../contexts/produtos/MarcaContext';
import { ProdutoProvider } from '../contexts/produtos/ProdutoContext';
import { ProdutoVariacaoProvider } from '../contexts/produtos/ProdutoVariacaoContext';
import { AdicionalProvider } from '../contexts/produtos/AdicionalContext';
import { VariacaoProvider } from '../contexts/produtos/VariacaoContext';
import { VariacaoItemProvider } from '../contexts/produtos/VariacaoItemContext';
import { ConjuntoProvider } from '../contexts/produtos/combos/ConjuntoContext';
import { ConjuntoItemProvider } from '../contexts/produtos/combos/ConjuntoItemContext';
import { ProdutoConjuntoProvider } from '../contexts/produtos/combos/ProdutoConjuntoContext';
import { ApresentacaoProvider } from '../contexts/produtos/combos/ApresentacaoContext';
import { ProdutoApresentacaoProvider } from '../contexts/produtos/combos/ProdutoApresentacaoContext';
import { ApresentacaoConjuntoProvider } from '../contexts/produtos/combos/ApresentacaoConjuntoContext';
import { BarraProvider } from '../contexts/produtos/BarraContext';
import { NCMProvider } from '../contexts/produtos/NCMContext';
import { ProdutoFornecProvider } from '../contexts/produtos/ProdutoFornecContext';
import { DestaqueProdutoProvider } from '../contexts/produtos/DestaqueProdutoContext';


export default function ProdutosProvider({ children }) {
  return (
    <VariacaoProvider>
        <VariacaoItemProvider>
            <UnMedidaProvider>
                <GrupoProvider>
                    <SubGrupoProvider>
                        <MarcaProvider>
                            <NCMProvider>
                                <BarraProvider>
                                    <ProdutoFornecProvider>
                                        <DestaqueProdutoProvider>
                                            <AdicionalProvider>
                                                <ProdutoProvider><ProdutoVariacaoProvider>
                                                    <ConjuntoProvider>
                                                        <ConjuntoItemProvider>
                                                            <ProdutoConjuntoProvider>
                                                                <ApresentacaoProvider>
                                                                    <ApresentacaoConjuntoProvider>
                                                                        <ProdutoApresentacaoProvider>
                                                                            {children}
                                                                        </ProdutoApresentacaoProvider>
                                                                    </ApresentacaoConjuntoProvider>
                                                                </ApresentacaoProvider>
                                                            </ProdutoConjuntoProvider>
                                                        </ConjuntoItemProvider>
                                                    </ConjuntoProvider>
                                                </ProdutoVariacaoProvider></ProdutoProvider>
                                            </AdicionalProvider>
                                        </DestaqueProdutoProvider>
                                    </ProdutoFornecProvider>
                                </BarraProvider>
                            </NCMProvider>
                        </MarcaProvider>
                    </SubGrupoProvider>
                </GrupoProvider>
            </UnMedidaProvider>
        </VariacaoItemProvider>
    </VariacaoProvider>          
  );
}
